import faqItems from "./faq.json";
import { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";

export interface FaqItemProps {
  question: String;
  answer: String;
}

function FaqItem({ question, answer }: FaqItemProps) {
  const [open, setOpen] = useState(false);

  const answerStyle = `text-primary pl-10 pt-2 ${open ? "" : "hidden"}`;

  return (
    <div
      className="max-w-prose bg-surface m-2 p-4 hover:cursor-pointer rounded-2xl"
      onClick={() => setOpen(!open)}
    >
      <div className="text-start flex flex-row items-center align-middle">
        <div className="pr-5">
          {!open && <FaPlus size={20} color="#ff5722" />}
          {open && <FaMinus size={20} color="#ff5722" />}
        </div>
        <h3 className="text-primary text-xl pr-10">{question}</h3>
      </div>
      <p className={answerStyle}>{answer}</p>
    </div>
  );
}

function FAQ() {
  return (
    <div
      id="faq"
      className="bg-gradient-to-b from-background to-black pb-10 flex flex-col content-center justify-center items-center"
    >
      <h1 className="text-primary text-6xl md:text-8xl p-10 pt-20 pb-10">
        FAQ
      </h1>
      <p className="text-center text-primary text-2xl mb-10">
        Below you'll find the answers to some frequently asked questions. <br />
        If you have any unanswered questions, don't hesitate to contact us via
        the form below.
      </p>
      <div className="m-5 grid lg:grid-cols-2 xl:grid-cols-3">
        {(faqItems as FaqItemProps[]).map((item) => (
          <FaqItem question={item.question} answer={item.answer} />
        ))}
      </div>
    </div>
  );
}

export default FAQ;
